import React from 'react';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateProjectWithTeamDto } from '../../../common/pokCore/autogenerated/pokApiClient/models';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { NewDatePicker } from '../../../app/components/NewDatePicker';

interface ProjectDatesFormProps {
  project: CreateUpdateProjectWithTeamDto;
  readOnly?: boolean;
  blockedDates?: boolean;
  propertyChange?: (obj: Partial<CreateUpdateProjectWithTeamDto>) => void;
  datesChanged: (dates: { startDate?: Date; endDate?: Date }) => void;
}

const MIN_PROJECT_DATE = '2024-01-01';

export const ProjectDatesForm: React.FC<ProjectDatesFormProps> = props => {
  const { t, tk } = useTranslation('projectLng');

  return (
    <>
      <FormRow controlId="startDate" label={t(tk.common.startDate)}>
        <NewDatePicker
          value={props.project.startDate}
          dateChanged={d => props.datesChanged({ startDate: d })}
          readOnly={props.readOnly || props.blockedDates}
          min_date={MIN_PROJECT_DATE}
        />
      </FormRow>
      <FormRow controlId="endDate" label={t(tk.common.endDate)}>
        <NewDatePicker
          value={props.project.endDate}
          dateChanged={d => props.datesChanged({ endDate: d })}
          readOnly={props.readOnly || props.blockedDates}
        />
      </FormRow>
    </>
  );
};
